// Shared resource identity for @ autocomplete and highlights (§10c/§18).
// Only canonical type keys select colors/icons; resource-provided HTML/colors
// never become markup or CSS. All three mention hooks use this mapping.
const TYPES = Object.freeze(Object.assign(Object.create(null), {
  agent: ['purple', 'bot', 'agent'], tool: ['blue', 'tool', 'tool'],
  user: ['green', 'user', 'user'], credential: ['yellow', 'key', 'key'],
  key: ['yellow', 'key', 'key'], skill: ['coral', 'star', 'skill'],
  app: ['blue', 'grid', 'app'], workflow: ['blue', 'flow', 'workflow'],
  collection: ['cyan', 'db', 'data'], datapack: ['cyan', 'db', 'data'],
  datapack_pack: ['cyan', 'db', 'data'], context_block: ['blue', 'book', 'context'],
  file: ['blue', 'file', 'file']
}))
export const escapeMentionHTML = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]))
export const escapeMentionText = value => String(value ?? "").replace(/[&<>]/g, ch => ({"&":"&amp;","<":"&lt;",">":"&gt;"}[ch]))
export function mentionKind(type) { return (TYPES[type] || TYPES.tool)[2] }
export function mentionBadge(type) {
  const [tone, icon, kind] = TYPES[type] || TYPES.tool
  return `<span class="aios-mention-icon av av--xs av--${tone}" data-mention-kind="${kind}"><svg class="ic" aria-hidden="true"><use href="/images/aios/design-system/icons.svg#i-${icon}"/></svg></span>`
}
// App rows wear the ResourceVisual tile (SeivaWeb.ResourceVisual, same rule as
// the resource lists): the solution mark for a Hub App, else the App's own
// icon on its category color, else the grid glyph. The server validates every
// field (slug, icon class, hex); this only builds markup from a closed shape.
const SOLUTION_SLUG = /^[a-z0-9-]{1,40}$/
const ICON_CLASS = /^[a-z0-9-]{1,60}$/
const CATEGORY = /^[a-z]{1,20}$/
const HEX = /^#[0-9a-fA-F]{3,8}$/
const SOLUTION_VARIANTS = [['accountfy', 'light'], ['accountfy', 'dark'], ['mogno', 'light'], ['mogno', 'dark']]
export function appVisualBadge(visual) {
  if (!visual || typeof visual !== 'object') return null
  const category = CATEGORY.test(visual.category || '') ? ` data-category="${visual.category}"` : ''
  const color = HEX.test(visual.color || '') ? ` style="--rv-color:${visual.color}"` : ''
  const open = (type) => `<span class="aios-mention-icon rv rv--${type}" data-rv-kind="apps" data-mention-kind="app"${category}${color}>`
  if (visual.type === 'solution' && SOLUTION_SLUG.test(visual.solution || '')) {
    const imgs = SOLUTION_VARIANTS.map(([brand, tone]) => `<img class="aios-solution-${tone}" data-brand-icon="${brand}" src="/images/aios/design-system/solutions-icons/${brand}-icon-${visual.solution}-${tone}.svg" loading="lazy" alt="">`).join('')
    return `${open('solution')}<picture class="aios-solution-icon">${imgs}</picture></span>`
  }
  if (visual.type === 'icon' && ICON_CLASS.test(visual.icon_class || '')) {
    const glyph = visual.icon_class === 'accountfy-icon' ? escapeMentionHTML(visual.icon_glyph || '') : ''
    return `${open('icon')}<span class="${visual.icon_class} ic">${glyph}</span></span>`
  }
  if (visual.type === 'glyph' || visual.type === 'icon') {
    return `${open('glyph')}<svg class="ic" aria-hidden="true"><use href="/images/aios/design-system/icons.svg#i-grid"/></svg></span>`
  }
  return null
}
export function mentionRow(candidate, index, selected, prefix) {
  const kind = mentionKind(candidate.type)
  const badge = (candidate.type === 'app' && appVisualBadge(candidate.visual)) || mentionBadge(candidate.type)
  return `<div class="${prefix}-item menu__item${selected ? ` ${prefix}-sel` : ''}" data-idx="${index}" role="option" aria-selected="${selected}"${selected ? ' aria-current="true"' : ''} data-mention-kind="${kind}">${badge}<div class="aios-mention-label"><b>${escapeMentionHTML(candidate.label)}</b>${candidate.subtitle || candidate.sublabel ? `<small>${escapeMentionHTML(candidate.subtitle || candidate.sublabel)}</small>` : ''}</div></div>`
}
export function mentionHighlight(type, name, tag = 'span') {
  return `<${tag} class="mention aios-mention-token m-${mentionKind(type)}">@${escapeMentionHTML(name)}</${tag}>`
}
